import {TrackEntity} from '@spout/any-shared/models';

export function tracksIdsMatch(a: TrackEntity, b: TrackEntity): boolean {
  return a.id === b.id;
}
